import { useRecoilState } from "recoil";
import { recoilStates } from "src/recoil/recoilStates";
import Button from "../Button";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

export default function NoBookingContent(props: { isRejectedByAllClubs?: boolean }) {
  const navigate = useNavigate();
  const [group] = useRecoilState(recoilStates.group);
  const [user] = useRecoilState(recoilStates.user);

  const myMemberData = group.members.find((m) => {
    return m.teeshot_user_id && m.teeshot_user_id === user.id;
  });

  const isGroupOfficer = [1, 2, 4].includes(myMemberData?.booking_group_member_level_id || 0);
  return (
    <Container className="d-flex fd-c gap-2 flex-1">
      <div className="button-container">
        <Button
          style={{ fontSize: "16px" }}
          $colorTheme="green"
          $round={true}
          $buttonSize="md"
          disabled={!isGroupOfficer}
          onClick={() => navigate("/year-booking/booking-register")}
        >
          골프장 예약신청
        </Button>
      </div>
    </Container>
  );
}

const Container = styled.div`
  position: relative;
  padding-bottom: 100px;

  .button-container {
    position: fixed;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    max-width: 800px;
    padding: 8px 16px 26px 16px;
    background: linear-gradient(
      0deg,
      #fdfdfd 0%,
      #fdfdfd 60%,
      rgba(253, 253, 253, 0.3) 85%,
      rgba(253, 253, 253, 0) 100%
    );
    backdrop-filter: blur(10px);
    z-index: 1000;
    display: flex;
    gap: 8px;

    > button {
      flex: 1;
    }
  }
`;
